'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contentTotalLimitSelector = exports.contentTotalCountSelector = exports.contentElementCountSelector = exports.elementCountSelector = undefined;

var _reselect = require('reselect');

var _elementHelper = require('../../../common/elements/elementHelper');

var elementCountSelector = exports.elementCountSelector = (0, _reselect.createSelector)(function (state) {
    return state.get('elementCount');
}, function (elementCount) {
    return elementCount;
});

var contentElementCountSelector = exports.contentElementCountSelector = (0, _reselect.createSelector)(elementCountSelector, function (elementCount) {
    return elementCount.filter(function (count, type) {
        return (0, _elementHelper.isContent)(type);
    });
});

var contentTotalCountSelector = exports.contentTotalCountSelector = (0, _reselect.createSelector)(contentElementCountSelector, function (elementCount) {
    return elementCount.reduce(function (count, typeCount) {
        return count + typeCount;
    }, 0);
});

var contentTotalLimitSelector = exports.contentTotalLimitSelector = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['app', 'currentUser']);
}, function (currentUser) {
    return currentUser.get('contentLimit');
});


//////////////////
// WEBPACK FOOTER
// ./src/client/user/elementCount/elementCountSelector.js
// module id = 170
// module chunks = 0